import { flyGaLogic } from '../../listings-client/util/flyGaLogic'

const logHelper = (category, action, label) => {
  flyGaLogic.fire.logUpsellTray({
    category: category,
    action: action,
    label: label,
  })
}

const logClickTile = (tilePosition) => {
  logHelper('bf-add-on', 'tile-click', tilePosition)
}

const logGetAirlineAndFB = (airline, farebrand) => {
  logHelper('bf-add-on', farebrand, airline)
}

export { logClickTile, logGetAirlineAndFB }
